import React from 'react';
import { useLanguage } from '@/shared/hooks/useLanguage';
import { useTheme } from '@/app/contexts/ThemeContext';
import { OrderSummary, PaymentMethod } from '../types/pricing.types';
import OrderSummaryCard from './OrderSummaryCard';

interface OrderSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  orderSummary: OrderSummary;
  onPayment: (method: PaymentMethod) => void;
  formatPrice: (price: number) => string;
}

const OrderSummaryModal: React.FC<OrderSummaryModalProps> = ({
  isOpen,
  onClose,
  orderSummary,
  onPayment,
  formatPrice,
}) => {
  const { t, isRTL } = useLanguage();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(2px)',
      }}
      onClick={onClose}
    >
      <div
        className={`rounded-2xl shadow-2xl w-full max-w-2xl mx-4 ${
          isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'
        }`}
        onClick={(e) => e.stopPropagation()}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {/* Header */}
        <div className={`flex justify-between items-center p-6 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
          <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {t('pricing.orderSummary.title')}
          </h2>
          <button
            onClick={onClose}
            className={`text-2xl font-bold ${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <OrderSummaryCard
            orderSummary={orderSummary}
            onPayment={onPayment}
            formatPrice={formatPrice}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryModal;

